export const PRODUCTSTATUS_SHOW_RESET = 'PRODUCTSTATUS_SHOW_RESET'
export const PRODUCTSTATUS_SHOW_SET_ERROR = 'PRODUCTSTATUS_SHOW_SET_ERROR'
export const PRODUCTSTATUS_SHOW_SET_RETRIEVED = 'PRODUCTSTATUS_SHOW_SET_RETRIEVED'
export const PRODUCTSTATUS_SHOW_TOGGLE_LOADING = 'PRODUCTSTATUS_SHOW_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/product_status/show/mutation_types.js